import React from "react";

import { OnPremAssetDetailsPageHeader } from "../../../header/OnPremAssetDetailsPageHeader";
import { EditOnPremAssetContentForm } from "./EditOnPremAssetContentForm";

export const EditOnPremAssetContentDashboard = (): JSX.Element => {
    return (
        <>
            <OnPremAssetDetailsPageHeader />
            <EditOnPremAssetContentForm />
        </>
    );
};
